/**
 * User: mphee
 * Date: 2/1/13
 * Time: 12:53 PM
 *
 * todo: create a base notification and extend that....  This isn't done correctly.
 */
define(function (require) {
    'use strict';
    var $ = require('jquery'),
        _ = require('underscore'),
        Backbone = require('backbone'),

        notificationListener = require('common/NotificationListener'),

        html_template = require('common/templates/notifications/NotificationViewer.html'),
        template = _.template(html_template);
    return Backbone.View.extend({

        initialize: function () {
            this.notification = this.options.notification;
            this.buttonText = this.options.buttonText;
            this.title = this.options.title;
            this.notificationText = this.options.notificationText;
            this.icon = this.options.icon;

            notificationListener.confirm(this.notification);
        },

        render: function () {
            var data = this._prepareData();

            this.$el.html(template(data));

            return this;
        },

        show: function () {
            $('div.banner-notification').fadeIn('slow');
        },

        _prepareData: function () {
            var data = {
                buttonText: this.buttonText,
                img: this.icon,
                title: this.title || this.notification.title,
                notification: this.notificationText || this.notification.notification,
                url: this.notification.url,
                i18n: i18n
            };

            return data;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/common/views/notifications/NotificationViewer.js
// module id = 1068
// module chunks = 26 27 28